import Img from "../../assets/img/rentProgStep1.png";

import styles from "../../ui/Tooltip/Tooltip.module.scss";

export const stepsDataRentProg = [
  {
    title: "Где найти API Токен?",
    description: (
      <ul className={styles.ulListContainer}>
        <li>На верхней навигационной панели найдите “Компания”.</li>
        <li>В открывшемся списке выберите “Настройки компании”.</li>
        <li>На странице перейдите во вкладку “Интеграции”.</li>
        <li>Найдите API Токен и скопируйте его.</li>
      </ul>
    ),
    imgSrc: Img,
  },
];
